export default __webpack_public_path__ + "static/media/social-facebook.39fe37a0.svg";